export function extractDepartmentNumber(zipCode: string | null): string {
  if (!zipCode) return "";

  const zip = zipCode.trim();
  if (!/^\d{5}$/.test(zip)) return "";

  if (zip.startsWith("97") || zip.startsWith("98")) {
    return zip.slice(0, 3);
  }

  if (zip.startsWith("20")) {
    return Number(zip) < 20_200 ? "2A" : "2B";
  }

  return zip.slice(0, 2);
}

export function resolveExportCity(
  place: {
    city: string | null;
    zip_code: string | null;
  } | null,
): string {
  if (!place) return "";
  if (isParisLocation(place.city, place.zip_code)) return "Paris";
  return place.city?.trim() ?? "";
}

export function resolveExportDepartmentName(
  place: {
    city: string | null;
    zip_code: string | null;
    department_name: string | null;
  } | null,
  eventDepartmentName: string | null,
): string {
  if (place && isParisLocation(place.city, place.zip_code)) {
    return "Paris";
  }

  return (
    place?.department_name?.trim() ||
    eventDepartmentName?.trim() ||
    ""
  );
}

export function formatParisArrondissement(zipCode: string | null): string | null {
  if (!zipCode) return null;

  const normalized = zipCode.trim();
  if (!/^750\d{2}$/.test(normalized)) return null;

  const number = Number(normalized.slice(3));
  if (!Number.isInteger(number) || number < 1 || number > 20) return null;

  if (number === 1) return "1er";
  return `${number}e`;
}

export function formatParisArrondissementNumber(
  zipCode: string | null,
): string | null {
  if (!zipCode) return null;

  const normalized = zipCode.trim();
  if (!/^750\d{2}$/.test(normalized)) return null;

  const number = Number(normalized.slice(3));
  if (!Number.isInteger(number) || number < 1 || number > 20) return null;

  return String(number);
}

export function resolveExportLocationLine(
  place: {
    name: string;
    city: string | null;
    zip_code: string | null;
  } | null,
): string {
  if (!place) return "";

  const placeName = place.name.trim();
  const departmentNumber = extractDepartmentNumber(place.zip_code);

  if (isParisLocation(place.city, place.zip_code)) {
    const arrondissement = formatParisArrondissementNumber(place.zip_code);
    if (placeName && arrondissement) {
      return `${placeName}, Paris ${arrondissement}`;
    }
    if (placeName) return placeName;
    if (arrondissement) return `Paris ${arrondissement}`;
    return "";
  }

  const city = resolveExportCity(place);
  return [placeName, city, departmentNumber]
    .filter((part) => part.length > 0)
    .join(", ");
}

export function isParisLocation(
  city: string | null,
  zipCode: string | null,
): boolean {
  if (city?.trim().toLowerCase() === "paris") return true;
  return formatParisArrondissement(zipCode) !== null;
}
